/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Saved_To_FavoritesInputs */

const en_saved_to_favorites = /** @type {(inputs: Saved_To_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved Assets`)
};

const es_saved_to_favorites = /** @type {(inputs: Saved_To_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activos Guardados`)
};

const fr_saved_to_favorites = /** @type {(inputs: Saved_To_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressources enregistrées`)
};

const de_saved_to_favorites = /** @type {(inputs: Saved_To_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeicherte Assets`)
};

const id_saved_to_favorites = /** @type {(inputs: Saved_To_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aset Disimpan`)
};

/** @type {(inputs: Saved_To_FavoritesInputs) => LocalizedString} */
const ja_saved_to_favorites = en_saved_to_favorites;

/** @type {(inputs: Saved_To_FavoritesInputs) => LocalizedString} */
const zh_saved_to_favorites = en_saved_to_favorites;

/** @type {(inputs: Saved_To_FavoritesInputs) => LocalizedString} */
const ar_saved_to_favorites = en_saved_to_favorites;

/** @type {(inputs: Saved_To_FavoritesInputs) => LocalizedString} */
const it_saved_to_favorites = en_saved_to_favorites;

/** @type {(inputs: Saved_To_FavoritesInputs) => LocalizedString} */
const ru_saved_to_favorites = en_saved_to_favorites;

/** @type {(inputs: Saved_To_FavoritesInputs) => LocalizedString} */
const pt_saved_to_favorites = en_saved_to_favorites;

/** @type {(inputs: Saved_To_FavoritesInputs) => LocalizedString} */
const ko_saved_to_favorites = en_saved_to_favorites;

/**
* | output |
* | --- |
* | "Saved Assets" |
*
* @param {Saved_To_FavoritesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const saved_to_favorites = /** @type {((inputs?: Saved_To_FavoritesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Saved_To_FavoritesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_saved_to_favorites(inputs)
	if (locale === "es") return es_saved_to_favorites(inputs)
	if (locale === "fr") return fr_saved_to_favorites(inputs)
	if (locale === "de") return de_saved_to_favorites(inputs)
	if (locale === "ja") return ja_saved_to_favorites(inputs)
	if (locale === "zh") return zh_saved_to_favorites(inputs)
	if (locale === "ar") return ar_saved_to_favorites(inputs)
	if (locale === "id") return id_saved_to_favorites(inputs)
	if (locale === "it") return it_saved_to_favorites(inputs)
	if (locale === "ru") return ru_saved_to_favorites(inputs)
	if (locale === "pt") return pt_saved_to_favorites(inputs)
	return ko_saved_to_favorites(inputs)
});